/** Codes stockés. Les libellés viennent de contact:form.fields.civility.options. */
export const CIVILITY_CODES = ["Monsieur", "Madame", "Other"] as const;

export type CivilityCode = (typeof CIVILITY_CODES)[number];

const MONSIEUR = new Set(["male", "m", "mr", "monsieur", "sir"]);
const MADAME = new Set(["female", "f", "mrs", "ms", "madame", "madam"]);
const OTHER = new Set(["other", "autre"]);

/** Ramène male/female et les variantes vers Monsieur, Madame ou Other. */
export function normalizeCivility(value?: string | null): CivilityCode | undefined {
  if (!value) return undefined;
  if ((CIVILITY_CODES as readonly string[]).includes(value)) return value as CivilityCode;

  const key = value.trim().toLowerCase();
  if (MONSIEUR.has(key)) return "Monsieur";
  if (MADAME.has(key)) return "Madame";
  if (OTHER.has(key)) return "Other";
  return undefined;
}
